export default __webpack_public_path__ + "static/media/flowers.75766537.svg";